import { Box, VStack, Icon, Tooltip, Image, Divider } from '@chakra-ui/react'
import { FiHome, FiCpu, FiSettings, FiGrid, FiSliders, FiUser } from 'react-icons/fi'
import { Link, useLocation } from 'react-router-dom'
import { IconType } from 'react-icons'
import lambdaLogo from '../assets/icons/lambda.png'
import historyIcon from '../assets/icons/history.svg'
import historyWhiteIcon from '../assets/icons/history-white.svg'
import globeIcon from '../assets/icons/globe.svg'
import globeWhiteIcon from '../assets/icons/globe-white.svg'

interface MenuItem {
  icon: IconType | string
  iconWhite?: string
  label: string
  path: string
  isCustom: boolean
}

export const Sidebar = () => {
  const location = useLocation()

  const mainMenuItems: MenuItem[] = [
    { icon: FiHome, label: 'Overview', path: '/', isCustom: false },
    { 
      icon: historyIcon, 
      iconWhite: historyWhiteIcon,
      label: 'History', 
      path: '/history', 
      isCustom: true 
    },
    { icon: FiCpu, label: 'Agents', path: '/agents', isCustom: false },
    { 
      icon: globeIcon, 
      iconWhite: globeWhiteIcon,
      label: 'Experience', 
      path: '/experience', 
      isCustom: true 
    },
    { icon: FiSettings, label: 'Config', path: '/config', isCustom: false }
  ]

  const bottomMenuItems: MenuItem[] = [
    { icon: FiGrid, label: 'Integrations', path: '/integrations', isCustom: false },
    { icon: FiSliders, label: 'Preferences', path: '/preferences', isCustom: false },
    { icon: FiUser, label: 'Account', path: '/account', isCustom: false }
  ]

  const renderMenuItem = (item: MenuItem) => {
    const isActive = location.pathname === item.path
    return (
      <Tooltip key={item.path} label={item.label} placement="right">
        <Link to={item.path} tabIndex={-1}>
          <Box
            p={3}
            borderRadius="md"
            bg={isActive ? 'blue.500' : 'transparent'}
            color={isActive ? 'white' : 'gray.600'}
            _hover={{ bg: isActive ? 'blue.600' : 'gray.100' }}
          >
            {item.isCustom ? (
              <Image 
                src={isActive ? (item.iconWhite as string) : (item.icon as string)} 
                boxSize="20px" 
              />
            ) : (
              <Icon as={item.icon as IconType} boxSize={5} />
            )}
          </Box>
        </Link>
      </Tooltip>
    )
  }

  return (
    <Box w="64px" bg="white" borderRight="1px" borderColor="gray.200">
      <VStack h="100%" justify="space-between" py={4}>
        <VStack spacing={4} align="center" w="full">
          <Box mb={4}>
            <Image src={lambdaLogo} alt="Lambda Logo" height="32px" />
          </Box>
          {mainMenuItems.map(renderMenuItem)}
        </VStack>
        
        <VStack spacing={4} align="center" w="full">
          <Divider />
          {bottomMenuItems.map(renderMenuItem)}
        </VStack>
      </VStack>
    </Box>
  )
}
